import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";

const ACTION_STYLES = {
  create: "bg-accent/10 text-accent", update: "bg-primary/10 text-primary",
  delete: "bg-red-100 text-red-600", login: "bg-slate-100 text-slate-600",
};

export default function AuditTab() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const pageSize = 25;

  useEffect(() => {
    api.get("/audit", { params: { page, page_size: pageSize } })
      .then(({ data }) => { setItems(data.items || []); setTotal(data.total || 0); });
  }, [page]);

  const pages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div data-testid="audit-tab">
      <div className="mb-4">
        <h3 className="font-display text-lg font-semibold text-secondary">Audit logs</h3>
        <p className="text-sm text-muted-foreground">Every create, update and delete across the system.</p>
      </div>
      <div className="rounded-xl border border-border bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>When</TableHead><TableHead>Actor</TableHead>
              <TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>IP</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 && (
              <TableRow><TableCell colSpan={5} className="py-8 text-center text-muted-foreground">No audit entries yet.</TableCell></TableRow>
            )}
            {items.map((a) => (
              <TableRow key={a.id} data-testid="audit-row">
                <TableCell className="text-sm">{String(a.created_at).slice(0, 19).replace("T", " ")}</TableCell>
                <TableCell className="font-medium">{a.actor_name || "—"}</TableCell>
                <TableCell><Badge className={`border-0 capitalize ${ACTION_STYLES[a.action] || "bg-slate-100 text-slate-600"}`}>{a.action}</Badge></TableCell>
                <TableCell className="text-sm" title={a.entity_id}>{a.entity_type} <span className="text-muted-foreground">#{String(a.entity_id).length > 12 ? String(a.entity_id).slice(0, 8) : a.entity_id}</span></TableCell>
                <TableCell className="text-sm text-muted-foreground">{a.ip || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <div className="mt-4 flex items-center justify-between text-sm text-muted-foreground">
        <span>{total} entries</span>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>Prev</Button>
          <span className="px-2 py-1.5">Page {page} of {pages}</span>
          <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => setPage((p) => p + 1)}>Next</Button>
        </div>
      </div>
    </div>
  );
}
